import dayjs from 'dayjs';
import { ContractItemPriceRaise, ContractItemPriceRaiseStatus } from '../../model/types';

const visibleStatuses = [ContractItemPriceRaiseStatus.ACCEPTED, ContractItemPriceRaiseStatus.COMPLETED];

export const getNotifiedPriceRaise = (priceRaises?: ContractItemPriceRaise[]): ContractItemPriceRaise | undefined => {
  const now = dayjs();

  return (priceRaises || [])
    .filter((item) => {
      const invoiceLeadDays = item.contract?.invoiceLeadDays;

      if (!visibleStatuses.includes(item.status) || !item.notificationSentAt || !item.priceRaiseDate || invoiceLeadDays == null) {
        return false;
      }

      if (dayjs(item.notificationSentAt).isAfter(now)) {
        return false;
      }

      const newPriceStartDate = dayjs(item.priceRaiseDate)
        .startOf('day')
        .add(invoiceLeadDays + 1, 'day');

      return newPriceStartDate.isValid() && now.isBefore(newPriceStartDate, 'day');
    })
    .sort((first, second) => dayjs(first.priceRaiseDate).valueOf() - dayjs(second.priceRaiseDate).valueOf())[0];
};
